/**
 * Web Vitals reporter — captura LCP, CLS, INP, TTFB, FCP por sesión
 * y los manda en batch al backend para analytics.
 *
 * Reporta una vez por métrica por página (web-vitals dispara cuando la
 * métrica está finalizada). Página = pathname al momento del report.
 *
 * Backend recibe: POST /api/metrics/web-vitals
 *   { name, value, rating, page, role, ts }
 */
import { onLCP, onCLS, onINP, onTTFB, onFCP } from "web-vitals";
import api from "@/lib/api";

let _userRole = null;
let _enabled = true;

const queue = [];
let flushTimer = null;

function flush() {
  if (queue.length === 0) return;
  // After logout the queue can still have post-pagehide metrics queued; sending
  // them generates 401s in server logs that obscure real auth bugs. Drop if
  // logged out.
  if (!localStorage.getItem("altiv_token")) {
    queue.length = 0;
    return;
  }
  const batch = queue.splice(0, queue.length);
  // Fire-and-forget; no await porque no queremos bloquear el render.
  api.post("/metrics/web-vitals", { metrics: batch }, { _skipNotifyOnFail: true }).catch(() => {});
}

function schedule() {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flush();
  }, 3000);
}

function report(metric) {
  if (!_enabled) return;
  queue.push({
    name: metric.name,
    value: Math.round(metric.value),
    rating: metric.rating, // 'good' | 'needs-improvement' | 'poor'
    page: window.location.pathname,
    role: _userRole,
    ts: new Date().toISOString(),
  });
  schedule();
}

export function initWebVitals(userRole) {
  _userRole = userRole || null;
  // Suscripciones únicas por sesión.
  if (window.__altivWebVitalsInit) return;
  window.__altivWebVitalsInit = true;
  try {
    onLCP(report);
    onCLS(report);
    onINP(report);
    onTTFB(report);
    onFCP(report);
  } catch {}
  // Flush al cerrar/background.
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
  window.addEventListener("pagehide", flush);
}

export function disableWebVitals() {
  _enabled = false;
}
